import { useTranslation } from 'react-i18next'
import { InputRadio } from '@/components/InputRadio/InputRadio'
import { useRegistrationAddressState } from '@/features/priceCalculator/usePriceCalculatorForm'
import { usePriceIntentValueOrThrow } from '@/features/priceCalculator/usePriceIntent'
import { type UseRegistrationAddressField } from '@/services/PriceCalculator/Field.types'

type Props = {
  label: string
}

export function UseRegistrationAddressField({ label }: Props) {
  const { t } = useTranslation('purchase-form')
  const priceIntent = usePriceIntentValueOrThrow()

  const [value, setValue] = useRegistrationAddressState(priceIntent.id)
  const handleChange = (newValue: string) => {
    setValue(newValue === 'true')
  }
  return (
    <InputRadio
      label={label}
      required={true}
      value={String(value)}
      onValueChange={handleChange}
      options={[
        { label: t('LABEL_YES'), value: 'true' },
        { label: t('LABEL_NO'), value: 'false' },
      ]}
    />
  )
}
